import { getSubscriptionGuids } from '@intigral/utils/lib/user';
import { useDispatch, useSelector } from 'react-redux';
import channelsUtil from '../helpers/channelsUtil';
import { appData } from '../helpers/common';
import user from '../helpers/user';
import { getConfiguration } from './useConfiguration';
import { usePPVEvents } from './usePPVEvents';
import { IStore } from '../interfaces/StoreTypes';
import { fetchUserChannelsList } from '../store/reducers/liveTvSlice';
import { useMemo } from 'react';
import { RootState } from '../store/index';
import { useChannelFavorites } from './useChannelFavorites';

const useChannelList = () => {
    const dispatch = useDispatch();
    const {
        favoriteChanels: { data: favoritesData },
    } = useChannelFavorites();

    //  FIXED: Using React Query-style hook instead of Redux generalConfiguration
    const { data: ppvEventConfig } = usePPVEvents();
    //  FIXED: Using React Query configuration instead of Redux
    const { operators = {} } = getConfiguration();
    const subscriptionGuids = getSubscriptionGuids(
        'epg',
        user.getUserInfo(),
        //  FIXED: Using React Query configuration instead of appData
        getConfiguration()?.paidVsFree || {}
    )
        .sort()
        .join('|');

    const updateChannelData = (channels, favoriteChannels = null) => {
        if (channels?.length) {
            const favorite = favoriteChannels || favoritesData;
            const genres = channelsUtil.compileLiveTVGenresWithCounts(channels, favorite);
            channelsUtil.setUserChannels(channels);
            dispatch(fetchUserChannelsList({ data: { channels, genres }, ppvEventConfig, operators }));
        }
    };

    return useMemo(
        () => ({
            subscriptionGuids,
            updateChannelData,
        }),
        [subscriptionGuids, favoritesData]
    );
};
export default useChannelList;
